import jsPDF from 'jspdf';
import * as THREE from "three";
import QRCode from "qrcode";

export async function pdfCreate(renderer, camera, scene, state){
    const btnPdf = document.querySelector('.pdf-icon')
    const btnScreen = document.querySelector('.screenshot-icon')
    const arDescScreen = document.querySelector('.ar-desc-icon')
    const demoBtn = document.querySelector('.request-btn')
    const overlay = document.querySelector('.ar-popup-overlay')
    const overlayDemo = document.querySelector('.demo-popup-overlay')
    const qrImage = document.querySelector('.ar-popup-overlay__qr')
    const closeBtn = document.querySelector('#close-popup')
    const closeBtnDemo = document.querySelector('#close-demo-popup')

    arDescScreen.addEventListener('click', async () => {
        const material = document.querySelector('input[name="material"]:checked')?.value || 'default'

        const arUrl = `${window.location.href.split('?')[0]}?ar=true&material=${material}`;

        const qrDataUrl = await QRCode.toDataURL(arUrl, {
            width: 300,
            margin: 2
        });

        showArPopup(qrDataUrl);
    })

    demoBtn.addEventListener('click', async () => {
        showDemoPopup();
    })

    btnPdf.addEventListener('click', async () => {
        await downloadPdf()
    })

    btnScreen.addEventListener('click', async () => {
        downloadScreenshot()
    })

    function showArPopup(qrImageSrc) {
        overlay.style.display = 'flex';

        qrImage.src = qrImageSrc;

        closeBtn.onclick = () => overlay.style.display = 'none';

        overlay.onclick = (e) => {
            if (e.target === overlay) overlay.style.display = 'none';
        };
    }

    function showDemoPopup() {
        overlayDemo.style.display = 'flex';

        closeBtnDemo.onclick = () => overlayDemo.style.display = 'none';

        overlayDemo.onclick = (e) => {
            if (e.target === overlayDemo) overlayDemo.style.display = 'none';
        };
    }


    async function downloadPdf() {
        const material = document.querySelector('input[name="material"]:checked')?.value || 'default'
        const modelName = 'Wall Street Desk'
        const price = `${document.querySelector('.price-value').textContent} $`
        const woodText = document.querySelector('.materials-wood').textContent

        const arUrl = `${window.location.href.split('?')[0]}?ar=true&material=${material}`
        const currentSize = document.querySelector('#canvas-container').getBoundingClientRect().width

        state.currentModel.rotation.set(0, 0, 0)

        const isLarge = currentSize > 600

        // 1100

        const currentSizeForLooksMain = ()=>{
            if (currentSize > 1100) return  new THREE.Vector3(0.5, 1.5, 1.5)
            if (currentSize > 600) return  new THREE.Vector3(0.5, 1.5, 1.5)
            return  new THREE.Vector3(0.5, 1.2, 2)
        }

        const currentSizeForLooksFront = ()=>{
            if (currentSize > 1100) return  new THREE.Vector3(0, 0.5, 1.1)
            if (currentSize > 600) return  new THREE.Vector3(0, 0.5, 1.6)
            return  new THREE.Vector3(0, 0.5, 2.2)
        }

        const currentSizeForLooksBack = ()=>{
            if (currentSize > 1100) return  new THREE.Vector3(0, 0.5, -1.1)
            if (currentSize > 600) return  new THREE.Vector3(0, 0.5, -1.6)
            return  new THREE.Vector3(0, 0.5, -2.2)
        }

        const currentSizeForLooksLeft = ()=>{
            if (currentSize > 1100) return  new THREE.Vector3(-1.5, 0.5, 0)
            if (currentSize > 600) return  new THREE.Vector3(-1.8, 0.5, 0)
            return  new THREE.Vector3(-2.2, 0.5, 0)
        }

        const currentSizeForLooksRight = ()=>{
            if (currentSize > 1100) return  new THREE.Vector3(1.5, 0.5, 0)
            if (currentSize > 600) return  new THREE.Vector3(1.8, 0.5, 0)
            return  new THREE.Vector3(2.2, 0.5, 0)
        }



        const screenshots = {
            main: captureView(currentSizeForLooksMain()),
            front: captureView(currentSizeForLooksFront()),
            back: captureView(currentSizeForLooksBack()),
            left: captureView(currentSizeForLooksLeft()),
            right: captureView(currentSizeForLooksRight())
        }

        const pdf = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4'
        })

        const pageWidth = pdf.internal.pageSize.getWidth()
        const pageHeight = pdf.internal.pageSize.getHeight()
        const aspect = renderer.domElement.width / renderer.domElement.height

        // --- СТРАНИЦА 1: ГЛАВНАЯ ---
        const imgWidth = isLarge ? 250 : 160

        pdf.addImage(screenshots.main, 'PNG', pageWidth / 2.5 - (isLarge ? 40 : 0), 20, imgWidth, imgWidth / aspect)


        pdf.setFillColor(245, 245, 245)
        pdf.rect(0, 0, pageWidth / 2.5, pageHeight, 'F')

        pdf.setTextColor(40, 40, 40)
        pdf.setFontSize(16)
        pdf.setFont('helvetica', )
        pdf.text('Demo example', 15, 30)

        pdf.setTextColor(40, 40, 40)
        pdf.setFontSize(28)
        pdf.setFont('helvetica', 'bold')
        pdf.text(modelName.toUpperCase(), 15, 40)

        pdf.setFontSize(28)
        pdf.text(price, 15, 52)

        pdf.setTextColor(40, 40, 40)
        pdf.setFontSize(8)
        pdf.setFont('helvetica', 'italic')
        pdf.text('*The indicated cost is for example purposes only', 15, 60)

        pdf.setFontSize(14)
        pdf.setTextColor(60, 60, 60)
        let yInfo = 100
        const xInfo = 15

        pdf.text('SPECIFICATIONS:', xInfo, yInfo)
        pdf.setLineWidth(0.5)
        pdf.line(xInfo, yInfo + 2, xInfo + 30, yInfo + 2)

        pdf.setFont('helvetica', 'normal')
        yInfo += 15
        pdf.text('Color:', xInfo, yInfo)
        pdf.setFont('helvetica', 'bold')
        pdf.text(woodText, xInfo, yInfo + 7)

        // --- СТРАНИЦА 2: ГАЛЕРЕЯ ---
        pdf.addPage()
        pdf.setFontSize(18)
        pdf.setTextColor(40, 40, 40)
        pdf.text('VIEW FROM ALL SIDES', pageWidth / 2, 15, { align: 'center' })

        const gridW = 120
        const gridH = gridW / aspect
        pdf.addImage(screenshots.front, 'PNG', 15, 25, gridW, gridH)
        pdf.addImage(screenshots.back, 'PNG', 160, 25, gridW, gridH)
        pdf.addImage(screenshots.left, 'PNG', 15, 110, gridW, gridH)
        pdf.addImage(screenshots.right, 'PNG', 160, 110, gridW, gridH)

        // --- СТРАНИЦА 3: AR ---
        pdf.addPage()
        pdf.setFillColor(30, 30, 30)
        pdf.rect(0, 0, pageWidth, pageHeight, 'F')

        const qrSize = 80
        const qrDataUrl = await QRCode.toDataURL(arUrl, {
            margin: 1,
            width: 400,
            color: { dark: '#000000', light: '#ffffff' }
        })

        pdf.setFillColor(255, 255, 255)
        pdf.roundedRect(pageWidth / 2 - qrSize / 2 - 10, 45, qrSize + 20, qrSize + 20, 5, 5, 'F')
        pdf.addImage(qrDataUrl, 'PNG', pageWidth / 2 - qrSize / 2, 55, qrSize, qrSize)

        pdf.setTextColor(255, 255, 255)
        pdf.setFontSize(24)
        pdf.text('EXPERIENCE IN AR', pageWidth / 2, 25, { align: 'center' })

        pdf.setFontSize(12)
        pdf.text('Scan the QR code with your smartphone camera to open', pageWidth / 2, 33, { align: 'center' })
        pdf.text('AR mode and see how the model will look in your room', pageWidth / 2, 38, { align: 'center' })



        pdf.save(`${modelName}.pdf`)
    }

    function captureView(position) {
        const currentSize = document.querySelector('#canvas-container').getBoundingClientRect().width

        const oldBackground = scene.background;

        scene.background = new THREE.Color(0xffffff);
        camera.position.copy(position);
        camera.lookAt(currentSize > 600 ? new THREE.Vector3(0, 0.5, 0): new THREE.Vector3(0, 0, 0));
        renderer.render(scene, camera);
        scene.background = oldBackground;
        return renderer.domElement.toDataURL('image/png');
    }



    function downloadScreenshot() {
        const canvas = renderer.domElement;

        const image = canvas.toDataURL('image/png');

        const link = document.createElement('a');
        link.href = image;
        link.download = 'model-screenshot.png';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}